<template>
  <div class="card-item card-item-accuracy">
    <icon-accuracy class="icon" v-ifield-b-tooltip="iconTooltipText" />
    <span
      ref="truncTarget"
      class="text ellipsis"
      v-ifield-b-tooltip="tooltipOption"
    >
      {{ text }}
    </span>
  </div>
</template>

<script>
import { toRefs } from 'vue'
import IconAccuracy from '@/assets/ifield/ic_positioning-accuracy.svg?component'
import { useIsTruncated } from '@/composables/UseIsTruncated'
import { useUserStatusAdditionalItemAccuracy } from '@/composables/user/additionalItem'

export default {
  name: 'AppCardMemberItemAccuracy',
  components: {
    IconAccuracy,
  },
  inheritAttrs: false,
  props: {
    /**
     * 測位精度値
     */
    accuracy: {
      type: Number,
      default: null,
    },
  },
  setup(props) {
    const { accuracy } = toRefs(props)
    const { truncTarget, isTruncated } = useIsTruncated()
    const { accuracyText } = useUserStatusAdditionalItemAccuracy({ accuracy })
    return { truncTarget, isTruncated, text: accuracyText }
  },
  computed: {
    /**
     * アイコン部ツールチップテキスト
     * @type {string}
     */
    iconTooltipText: function () {
      return `${this.$t('appCardMemberItemAccuracy.accuracy')} : ${this.text}`
    },
    /**
     * ツールチップオプション
     * @type {Object}
     */
    tooltipOption: function () {
      return {
        title: this.text,
        disabled: !this.isTruncated,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@use '../../../assets/scss/parts/member/card-member-item';
</style>
